import React from "react";
import { SlideShell } from "../../../shared/components/SlideShell";

const IMG = "https://images.unsplash.com/photo-1758272133542-b3107b947fc2";

export const Slide2 = ({ t, total, onActive }) => {
  return (
    <SlideShell index={1} total={total} onActive={onActive} label="Core Idea">
      <div className="absolute inset-0 radial-teal opacity-70" />
      <div className="relative z-10 flex flex-col h-full w-full max-w-7xl px-6 md:px-12">
        <div className="overline mb-8 shrink-0">{t.overline}</div>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 flex-1 items-center pb-12">
          <div className="lg:col-span-7">
            <h2 className="font-display font-medium text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tighter">
            {t.heading}
          </h2>
          <p className="mt-8 text-lg md:text-xl text-neutral-300 font-light leading-relaxed max-w-xl">
            {t.body}
          </p>
          <ul className="mt-10 grid grid-cols-2 gap-4 max-w-xl">
            {t.bullets.map((b, i) => (
              <li
                key={i}
                className="glass lift rounded-xl px-4 py-3 text-sm text-neutral-300"
                data-testid={`s2-bullet-${i}`}
              >
                <span className="text-[var(--ph-accent)] mr-2">·</span>
                {b}
              </li>
            ))}
          </ul>
        </div>

        <div className="lg:col-span-5 flex items-center">
          <div className="relative w-full">
            <div className="absolute -inset-3 rounded-3xl bg-[var(--ph-accent-glow)] blur-2xl" />
            <div className="relative glass-strong rounded-3xl overflow-hidden aspect-[4/5] gold-glow">
              <img
                src={IMG}
                alt="Community"
                className="w-full h-full object-cover"
                style={{ filter: "saturate(0.85) contrast(1.05)" }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
              <div className="absolute bottom-6 left-6 right-6">
                <div className="font-mono text-[10px] tracking-widest text-[var(--ph-accent)] mb-2">
                  TRUST · DENSITY · DISTRIBUTION
                </div>
                <div className="font-display text-2xl">A community already moves together.</div>
              </div>
            </div>
          </div>
        </div>
        </div>
      </div>
    </SlideShell>
  );
};


